export const RETURN_TO_APPLICATION_AUTO = 'return_to_application_auto'
export const INSTANT_DASHING_V2 = 'instant_dashing_v2'
export const IS_AT_CAPACITY_V2 = 'is_at_capacity_v2'
export const DX_CRO_LP_GRADUATION_Q1_2020 = 'dx_cro_lp_graduation_q1_2020'
export const BACKGROUND_CHECK_SPLIT_3PG = 'background_check_split_3pg'
export const DX_ID_FAST_PAY_Q1_2020 = 'dx_id_fast_pay_q1_2020'
export const COVID_RUNNERS_Q1_2020 = 'covid_runners_q1_2020'
export const NEEDS_VEHICLE_INFO = 'needs_vehicle_info'

export default {
  RETURN_TO_APPLICATION_AUTO,
  INSTANT_DASHING_V2,
  IS_AT_CAPACITY_V2,
  DX_CRO_LP_GRADUATION_Q1_2020,
  BACKGROUND_CHECK_SPLIT_3PG,
  DX_ID_FAST_PAY_Q1_2020,
  COVID_RUNNERS_Q1_2020,
  NEEDS_VEHICLE_INFO,
}
